<div class="btn-container container">
  <button color="primary" class="back" mat-raised-button (click)="back()">
    <mat-icon matPrefix>chevron_left</mat-icon>
    <small>BACK</small>
  </button>
</div>
<app-preview-fundraiser />
